<template>
	<div class="LabourPlaningDashboard">
		<app-sales-performance />
		<report-tab />
		<ReportTable :table-data="getAnalyticsData">
			<h3 slot="headingOfTable">
				<!-- Sales by location -->
			</h3>
			<template slot="button" slot-scope="{ element, indexOfRow }">
				<button
					v-if="disabled"
					:class="[
						element.value == 'Consolidated'
							? 'first-bold-button'
							: 'first-button'
					]"
					style="color: gray;"
				>
					{{ element.value ? element.value : "-" }}
				</button>
				<button
					v-else
					:class="[
						element.value == 'Consolidated'
							? 'first-bold-button'
							: 'first-button'
					]"
					@click="rowButtonClicked(element, indexOfRow)"
				>
					{{ element.value ? element.value : "-" }}
				</button>
			</template>
		</ReportTable>
		<!-- <DevExtremeSheduler /> -->
		<FullCalendar
			ref="fullCalendar"
			:plugins="calendarPlugins"
			:resource-columns="resourceColumns"
			:events="calendarEvents"
			:resources="calendarResouece"
			:html="calendarResouece"
			:editable="true"
			default-view="resourceTimeline"
			:views="views"
			@dateClick="handleDateClick"
		/>
	</div>
</template>
<script>
import ReportTable from "../reportTable/ReportTable";
import AppPieChart from "../../appPieChart/AppPieChart";
import ReportTab from "../reportTab/ReportTab";
import AppWowGraph from "../../appWowGraph/appWowGraph";
import AppWoowGraph from "../../appWoowGraph/appWoowGraph";
import { mapGetters } from "vuex";
import { AppSalesTabNC } from "../../../../../mixins/appSalesTabNC";
import { EventBus } from "../../../../eventBus";
// import DevExtremeSheduler from "../../../DevExtremeSheduler";
import FullCalendar from "@fullcalendar/vue";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import interactionPlugin from "@fullcalendar/interaction";
import AppSalesPerformance from "../reportPerformanceCard/ReportPerformanceCard";

export default {
	name: "LabourPlaningDashboard",
	components: {
		ReportTab,
		ReportTable,
		AppSalesPerformance,
		FullCalendar,
		AppWowGraph
		// DevExtremeSheduler
	},
	data() {
		return {
			calendarPlugins: [interactionPlugin, resourceTimelinePlugin],
			resourceColumns: [
				{
					labelText: "Employees",
					field: "title"
				},
				{
					labelText: "Shift",
					field: "shift"
				},
				{
					labelText: "Functions",
					field: "function"
				}
			],
			calendarEvents: [
				{
					resourceId: "a",
					title: "Morning",
					start: "Fri, 12 Jul 2019 06:24:58 GMT",
					end: "2019-10-12T15:00:00+05:30"
				},
				{
					resourceId: "atd",
					title: "101",
					start: "2019-10-08T00:00:00+05:30",
					end: "2019-10-08T07:00:00+05:30"
				},
				{
					resourceId: "atd",
					title: "101",
					start: "2019-10-08T07:00:00+05:30",
					end: "2019-10-08T08:00:00+05:30"
				},
				{
					resourceId: "d",
					title: "Frist",
					start: "2019-10-06T09:00:00+00:00",
					end: "2019-10-06T14:00:00+00:00"
				},
				{
					resourceId: "c",
					title: "Night",
					start: "2019-10-05T23:00:00+05:30",
					end: "2019-10-06T07:00:00+05:30"
				},
				{
					resourceId: "f",
					title: "Evining",
					start: "2019-10-06T07:30:00+00:00",
					end: "2019-10-06T09:30:00+00:00"
				},
				{
					resourceId: "b",
					title: "Morning",
					start: "2019-10-06T15:00:00+05:30",
					end: "2019-10-06T23:00:00+05:30"
				},
				{
					resourceId: "e",
					title: "Night",
					start: "2019-10-06T09:00:00+00:00",
					end: "2019-10-06T14:00:00+00:00"
				}
			],
			calendarResouece: [
				// { title: "ATD", id: "atd", eventColor: "black" },
				// { title: "Ideal" },
				// { title: "Scheduled" },
				{
					id: "a",
					function: "Manager",
					shift: "Night Shift",
					title: "Nikhil",
					eventColor: "skyblue"
				},
				{
					id: "b",
					function: "Manager",
					shift: "Night Shift",
					title: "Abhijeet",
					eventColor: "green"
				},
				{
					id: "c",
					function: "Manager",
					shift: "Night Shift",
					title: "Mayur",
					eventColor: "orange"
				},
				{
					id: "d",
					function: "Manager",
					shift: "Night Shift",
					title: "Anurag",
					eventColor: "red"
				},
				{
					id: "e",
					function: "Manager",
					shift: "Night Shift",
					title: "Mandar",
					eventColor: "blue"
				}
			],
			views: {
				timeGrid: {
					// options apply to timeGridWeek and timeGridDay views
				}
			},
			disabled: false,
			cliclableTable: true
		};
	},
	computed: {
		// ...mapState(["AnalyticsData"])
		...mapGetters(["getAnalyticsData"])
	},
	mounted() {
		EventBus.$on("disableFirstButton", payload => {
			this.disabled = payload;
		});
	},
	beforeDestroy() {
		EventBus.$off("disableFirstButton");
	},
	methods: {
		handleDateClick(arg) {
			console.log(arg, arg.dateStr);
			this.event_id = arg.resource.id;
			this.start_time = arg.date;
			var today = new Date(this.start_time);
			today.setHours(today.getHours() + 8);
			this.end_time = today.toISOString();
			if (
				arg.resource.id == "atd" ||
				arg.resource.title == "Ideal" ||
				arg.resource.title == "Scheduled"
			) {
				this.dialogVisible = false;
			} else {
				this.dialogVisible = true;
			}
			// if (confirm('Would you like to add an event to ' + arg.dateStr + ' ?')) {

			// }
		},
		rowButtonClicked(element, indexOfRow) {
			this.disabled = true;
			// console.log("element in sales location", element);
			if (element.isShowGraph) {
				this.showGraphForPartRow(indexOfRow);
			}
			EventBus.$emit("buttonClickedEvent", element);
		},
		showGraphForPartRow(index) {
			const row = this.getAnalyticsData.data.rows[index];
			this.$store.commit("setNameOfGraph", row[0].value);
			const headings = this.getAnalyticsData.data.headings;
			this.plotOnlyDateGroupGraph(headings, row);
		}
	}
};
</script>

<style>
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/timeline/main.css";
@import "~@fullcalendar/resource-timeline/main.css";
@import "./LabourPlaningDashboard.scss";
.demo {
	background: #fff;
}
.fc {
	background: #fff;
	padding: 10px 20px;
}
.fc-license-message {
	display: none;
}
.table {
	width: 100%;
	box-sizing: border-box;
	table-layout: fixed;
	border-collapse: collapse;
	border-spacing: 0;
	font-size: 1em;
}
.fc-scroller {
	height: auto !important;
}

.fc-toolbar h2 {
	font-size: 1rem;
}
/* .fc-resource-area {
	width: 10% !important;
} */

.fc-timeline th {
	font-weight: 200;
	font-size: 14px;
}

.fc-timeline td {
	font-size: 12px;
}

.fc-timeline .fc-head .fc-cell-content {
	padding-top: 5px;
	padding-bottom: 5px;
}

.fc-button-primary {
	background: #e29d5a;
	border: 1px solid #e29d5a;
	box-shadow: none;
}

.fc-button-primary:hover {
	background: transparent;
	border: 1px solid #e29d5a;
	color: black;
}

.fc-button-primary:not(:disabled):active,
.fc-button-primary:not(:disabled).fc-button-active {
	background: #e29d5a;
}

.fc-button:focus {
	box-shadow: none;
}

.fc-today-button {
	display: none;
}

.fc-body .fc-resource-area .fc-cell-content {
	padding: 20px 4px;
}
</style>
